document.addEventListener("DOMContentLoaded", function () {
  // Logo Slider
  if (document.querySelector('.logo-slider .swiper-wrapper')) {
    new Swiper('.logo-slider', {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      autoplay: { delay: 2000 },
      breakpoints: {
        0: { slidesPerView: 2 },
        480: { slidesPerView: 3 },
        768: { slidesPerView: 4 }
      }
    });
  }

  // Product Slider
  if (document.querySelector('.product-slider .swiper-wrapper')) {
    new Swiper('.product-slider', {
      slidesPerView: 3,
      spaceBetween: 20,
      loop: true,
      autoplay: { delay: 3000 },
      breakpoints: {
        0: { slidesPerView: 1 },
        576: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  }

  // Art of Matcha Slider
  if (document.querySelector('.art-of-matcha .swiper-wrapper')) {
    new Swiper('.art-of-matcha .swiper-container', {
      slidesPerView: 5,
      spaceBetween: 15,
      loop: true,
      breakpoints: {
        0: { slidesPerView: 3 },
        480: { slidesPerView: 4 },
        768: { slidesPerView: 5 }
      }
    });
  }

  // Harvest Text Slider
  if (document.querySelector('.harvest-text-slider .swiper-wrapper')) {
    new Swiper('.harvest-text-slider', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      loop: true,
      speed: 4000,
      autoplay: { delay: 0, disableOnInteraction: false },
      freeMode: true
    });
  }

  // Matcha Related Slider
  if (document.querySelector('.matcha-related .swiper-wrapper')) {
    new Swiper('.matcha-related', {
      slidesPerView: 3,
      spaceBetween: 20,
      loop: true,
      autoplay: { delay: 2500 },
      breakpoints: {
        0: { slidesPerView: 1 },
        576: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  }
});
